import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchPartiesName, fetchPartyHistory } from '../../../services/admin/party-service';
import { doFetch } from '../../../services/fetch/fetch.actions';
import History from './history';

class PartyHistory extends Component {
  loadParties = () => (dispatch) => {
    dispatch(doFetch(
      'PARTIES_NAME',
      fetchPartiesName()
        .then((res) => {
          if (!res.ok) {
            throw res.statusText;
          }
          return res.json();
        }),
    ));
  }

  componentDidMount = () => {
    const { partiesName: { fetched, fetching }, dispatch } = this.props;
    if (!fetched && !fetching) {
      dispatch(this.loadParties());
    }
  }

  search = (id, from, to) => {
    const { dispatch } = this.props;
    dispatch(doFetch('HISTORY_PARTY', fetchPartyHistory(
      id,
      `${from.getFullYear()}.${from.getMonth() + 1}.${from.getDate()}`,
      `${to.getFullYear()}.${to.getMonth() + 1}.${to.getDate()}`,
    ).then((res) => {
      if (!res.ok) throw res.statusText;
      return res.json();
    }), {
      id, from, to,
    }));
  }

  render() {
    const {
      partiesName: {
        payload: { Resources: parties },
        fetched,
      },
      historyParty,
    } = this.props;
    return (
      <History
        party
        names={parties}
        namesFetched={fetched}
        history={{ ...historyParty, payload: historyParty.payload || [] }}
        search={(id, from, to) => this.search(id, from, to)}
      />
    );
  }
}

PartyHistory.propTypes = {
  partiesName: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  historyParty: PropTypes.object.isRequired,
};

const mapStateToProps = ({ partiesName, historyParty }) => ({ partiesName, historyParty });

export default connect(mapStateToProps)(PartyHistory);
